import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        value: _vm.value,
        size: "md",
        title: "Сортировка",
        divider: "",
        "data-qa": "analyses_lpu_cards_sort_dialog",
        "slot-content-class": "py-0",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                VBtn,
                {
                  attrs: {
                    text: "",
                    "data-qa": "analyses_lpu_cards_sort_dialog_cancel",
                  },
                  on: { click: _setup.cancel },
                },
                [_vm._v("\n      Отменить\n    ")]
              ),
              _vm._v(" "),
              _c(
                VBtn,
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    "data-qa": "analyses_lpu_cards_sort_dialog_confirm",
                  },
                  on: { click: _setup.confirm },
                },
                [_vm._v("\n      Сортировать\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        VRadioGroup,
        {
          staticClass: "analyses-lpu-sort-dialog__group mt-0 pt-0",
          attrs: {
            "data-qa": "analyses_lpu_cards_sort_dialog_options",
            "hide-details": "",
          },
          model: {
            value: _setup.localSort,
            callback: function ($$v) {
              _setup.localSort = $$v
            },
            expression: "localSort",
          },
        },
        _vm._l(_setup.ANALYSES_LPU_SORT_ITEMS, function (item) {
          return _c(VRadio, {
            key: item.name,
            staticClass: "analyses-lpu-sort-dialog__option",
            attrs: {
              value: item.value,
              ripple: false,
              color: "primary",
              "data-qa": "analyses_lpu_cards_sort_option",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "text-body-1 text--text" }, [
                        _vm._v(
                          "\n          " + _vm._s(item.name) + "\n        "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }